import React, { useState, useEffect, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import useAxios from "../utils/useAxios";
import { hideModal, showModal } from "../utils/modalUtility";
import DonorCard from "./DonorCard";
import { useAppContext } from "../context/AppContext";
import "./AccountSettings.css";

const AccountSettings = () => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const { state } = useAppContext();

  const [formData, setFormData] = useState({
    user_id: "",
    full_name: "",
    address: "",
    city: "",
    state: "",
    zip_code: "",
    phone_number: "",
    email: "",
    favicon_url: "",
    // btg_magazine_status: "",
    connectivity_status: "",
    want_80g: "",
    pan_no: "",
    date_of_birth: "",
    patronship_level: "",
    whatsapp_number: "",
    is_address_confirmed: "",
    is_booked_calendar: "",
  });

  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [otpLoader, setOtpLoader] = useState(false);
  const [role, setRole] = useState(null);

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [receiptDetails, setReceiptDetails] = useState({});
  const [otpSentLoader, setOtpSentLoader] = useState(false);

  const [step, setStep] = useState(1);
  const axiosAPI = useAxios(); // Use the custom hook for Axios

  const [formImageData, setImageFormData] = useState({
    profile_pic: null,
  });

  const [loadingImages, setLoadingImages] = useState({
    profile_pic: false,
  });

  const fieldLabels = {
    profile_pic: "Favicon Image",
  };

  const profile_picInputRef = useRef(null);

  const receiptRef = useRef();

  const fetchUserData = async () => {
    try {
      const response = await axiosAPI.get(`/api/users/get-user-details`);
      const userData = response.data;
      setUsers(userData);
      // console.log("User Data ", userData);
      setCurrentUserId(userData?.user_id);
      setFormData(userData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching ads:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    // const role = JSON.parse(localStorage.getItem("user_role"));
    const role = state?.user?.role;
    setRole(role); // update state asynchronously
  }, []);

  // useEffect(() => {
  //   async function handleCheck() {
  //     if (role === "donor") {
  //       try {
  //         const response = await axiosAPI.get(`/api/users/get-user-status`);
  //         const { status } = response.data;
  //         // setPasswordStatus(passwordStatus);
  //         console.log("User Status:", status);

  //         if (status === "no") {
  //           setTimeout(() => {
  //             showModal("confirmationModal");
  //           }, 1000);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching status:", error);
  //       }
  //     }
  //   }

  //   handleCheck(); // run async logic
  // }, [role]);

  useEffect(() => {
    fetchUserData();
  }, []);

  const downloadPdf = () => {
    const input = receiptRef.current;

    html2canvas(input, {
      scale: 2,
      useCORS: true, // Enable CORS to allow external images to be loaded
      allowTaint: true, // Allow tainting the canvas
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`DonationReceipt_${receiptDetails?.full_name || "User"}.pdf`);
    });

    setShowPdfModal(false);
    setReceiptDetails("");
  };

  // console.log("ID",users)

  const fetchReceiptDetails = async () => {
    try {
      const response = await axiosAPI.get(
        `/api/donor/download-patron-card/${currentUserId}`,
      );
      // console.log("Reponse",response)
      setReceiptDetails(response.data.user_details);
      // setNotifications(response.data.results);
      // setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const openReceiptModal = (id) => {
    // console.log("id ", id);
    fetchReceiptDetails();
    setShowPdfModal(true);
  };

  // Handle form input changes
  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.id]: e.target.value });
  // };

  const handleChange = (e) => {
    const { id, value } = e.target;

    // Check if the field is PAN number and convert it to uppercase
    setFormData({
      ...formData,
      [id]: id === "pan_no" ? value.toUpperCase() : value, // Uppercase for PAN number
    });
  };

  // Handle file input change and preview the selected images, and submit image
  const handleFileChange = async (e, field, field_url) => {
    const file = e.target.files[0];
    // console.log("File is ", file);

    if (file) {
      const reader = new FileReader();

      // console.log("Reader", reader);

      reader.onloadend = async () => {
        // Append the file to the form data
        setImageFormData((prev) => ({
          ...prev,
          [field]: file, // Store the file object for submission
        }));
        // Append the file to the form data
        setFormData((prev) => ({
          ...prev,
          [field_url]: reader.result, // Store the base64 for preview
        }));

        setLoadingImages((prev) => ({
          ...prev,
          [field]: true, // Set loading spinner on
        }));

        const updatedFormData = new FormData();
        updatedFormData.append(field, file); // Append the changed image

        // console.log("File After Append", file);

        try {
          const response = await axiosAPI.put(
            `/api/users/update-user-details`,
            updatedFormData,
          );

          // console.log("Reponse 1", response);

          window.notifyMessage(
            "Success",
            // `${fieldLabels[field]} updated successfully!`,
            `Profile Pic updated successfully!`,
            "success",
          );
          fetchUserData();
          // Hide spinner after submission
          setLoadingImages((prev) => ({
            ...prev,
            [field]: false,
          }));
        } catch (error) {
          window.notifyMessage(
            "Error",
            // `Error updating ${fieldLabels[field]}.`,
            `Error updating Profile Pic.`,
            "danger",
          );

          // Hide spinner after error
          setLoadingImages((prev) => ({
            ...prev,
            [field]: false,
          }));
        }
      };

      reader.readAsDataURL(file); // Read the file for preview
    }
  };

  // Handle form submission to update user data

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    // Validate required fields
    // if (!formData.email) {
    //   window.notifyMessage(
    //     "Error",
    //     "Please fill in all required fields.",
    //     "danger"
    //   );
    //   setIsSubmitting(false);
    //   return;
    // }

    // console.log("1");

    const updatedFormData = new FormData();

    // for (const [key, value] of Object.entries(formData)) {
    //   console.log("Key ", key);
    //   console.log("Value ", value);
    // }

    // return

    // Loop through formData and append each value to the FormData
    for (const [key, value] of Object.entries(formData)) {
      // Skip specific fields
      if (["favicon_url"].includes(key)) {
        continue; // Skip these fields
      }

      if (value instanceof File) {
        updatedFormData.append(key, value); // Append the file object directly
      } else {
        updatedFormData.append(key, value); // Append the regular text fields
      }
    }

    // console.log(updatedFormData);

    // return

    try {
      const response = await axiosAPI.put(
        `/api/users/update-user-details`,
        updatedFormData,
      );

      // console.log("Reponse", response);

      window.notifyMessage(
        "Success",
        "Account details updated successfully!",
        "success",
      );
      setIsSubmitting(false);
    } catch (error) {
      console.log("Error", error);
      window.notifyMessage("Error", error?.response?.data?.message, "danger");
      setIsSubmitting(false);
    }
  };

  // Handle form submission to update user data
  const handleImageSubmit = async (e, field) => {
    e.preventDefault();
    const field1 = e.target.name; // This will capture the image field name (company_logo, profile_pic, or thumbnail_image)

    // console.log({ field });

    const updatedFormData = new FormData();
    const file = formImageData[field]; // Get the file for the specific image field

    if (file) {
      updatedFormData.append(field, file); // Append the changed image
    }
    // console.log(file);
    // console.log(updatedFormData);

    try {
      const response = await axiosAPI.put(
        `/api/users/update-user-details`,
        updatedFormData,
      );

      window.notifyMessage(
        "Success",
        "Account details updated successfully!",
        "success",
      );
      setLoadingImages((prev) => ({
        ...prev,
        [field]: false, // Hide spinner after submission
      }));
    } catch (error) {
      window.notifyMessage(
        "Error",
        "Error updating account details.",
        "danger",
      );
      setLoadingImages((prev) => ({
        ...prev,
        [field]: false, // Hide spinner after error
      }));
    }
  };

  async function handleOtpSubmit(e) {
    e.preventDefault();

    if (otp.length !== 6 || isNaN(otp)) {
      alert("Please enter a valid 6-digit OTP.");
      return;
    }

    if (newPassword.length < 6) {
      alert("Password must be at least 6 characters.");
      return;
    }

    // console.log("OTP:", otp);
    // console.log("New Password:", newPassword);

    const payload = {
      password: newPassword,
      otp: otp,
    };

    setOtpLoader(true);

    try {
      let response = await axiosAPI.post(`/api/whatsapp/verify-otp`, payload);
      // hideModal("staticBackdrop");
      // console.log("Response", response);
      if (response.status === 200) {
        window.notifyMessage(
          "Success",
          "Details Updated successfully",
          "success",
        );

        // Redirect after success
        window.location.href = "/logout";
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage(
          "Error",
          error.response.data.message, // Display specific error message from backend
          "danger",
        );
      } else {
        // Handle generic errors (e.g., network errors)
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }

    // Reset and close
    setOtpLoader(false);
    setOtp("");
    // hideModal("staticBackdrop");
    setNewPassword("");
  }

  async function otpHandler() {
    setOtpSentLoader(true);
    try {
      // 1. API Call to send OTP
      const response = await axiosAPI.get("/api/whatsapp/send-otp");

      if (response.status === 200) {
        // 2. Show Modal after successful OTP send
        showModal("staticBackdrop");

        // 3. Show success notification with backend message
        window.notifyMessage(
          "Success",
          response.data.message ||
            "OTP sent successfully on whatsapp and email",
          "success",
        );
        // console.log("OTP sent successfully");
      } else {
        console.error("Failed to send OTP:", response.data.message);
        alert("Failed to send OTP");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "There was an error sending OTP!";

      window.notifyMessage("Error", errorMessage, "danger");

      console.error("OTP send error:", errorMessage);
    }
    setOtpSentLoader(false);
  }

  function openOtpModal() {
    showModal("staticBackdrop");
  }

  useEffect(() => {
    // console.log({ formData });
  }, [formData]);

  // Confirmation Step - START

  const handleStepChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const validateStep = () => {
    switch (step) {
      case 1:
        return (formData.address ?? "").trim() !== "";
      case 2:
        return (formData.zip_code ?? "").trim() !== "";
      case 3:
        if (formData.want_80g === "") return false;
        if (formData.want_80g === "Y") {
          return (formData.pan_no ?? "").trim() !== "";
        }
        return true;
      case 4:
        return formData.date_of_birth !== "";
      case 5:
        return (formData.whatsapp_number ?? "").trim() !== "";
      case 6:
        return true;
      default:
        return false;
    }
  };

  const handleNext = async () => {
    if (!validateStep()) {
      alert("Please fill the required field.");
      return;
    }
    if (step < 6) {
      setStep(step + 1);
    } else {
      // Submit

      const payload = {
        pan_no: formData.pan_no || "",
        address: formData.address,
        zip_code: formData.zip_code,
        want_80g: formData.want_80g === "Y" ? "Y" : "N",
        dob: formData.date_of_birth || "",
        whatsapp_number: formData.whatsapp_number,
      };

      // console.log("Sending user details:", payload);

      try {
        const response = await axiosAPI.post(
          "/api/users/verify-user-details",
          payload,
        );

        if (response.status === 200) {
          window.notifyMessage(
            "Success",
            response.data.message || "Details submitted successfully",
            "success",
          );

          // Next step: show OTP modal if needed, or continue flow
        } else {
          console.error("Failed to submit details:", response.data.message);
          alert("Failed to submit details");
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          "There was an error submitting your details.";

        window.notifyMessage("Error", errorMessage, "danger");
        console.error("Submission error:", errorMessage);
      }

      alert("Form submitted successfully!");

      showModal("staticBackdrop");
    }
  };

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  if (loading)
    return (
      <div className="account-settings-loading-wrap">
        <div className="account-settings-loading-card">
          <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mb-0 mt-3">Preparing your account settings...</p>
        </div>
      </div>
    );

  return (
    <div className="container account-settings-page">
      <div className="page-inner account-settings-inner">
        <div className="account-settings-header d-flex flex-column flex-md-row justify-content-between align-items-center p-3">
          {/* Account Settings */}
          <div className="text-center text-md-start mb-3 mb-md-0">
            <p className="account-settings-kicker mb-1">Personal profile</p>
            <h4 className="mt-0 mb-0">Account Settings</h4>
            <small className="account-settings-subtitle">
              Keep your details updated for communication and services.
            </small>
          </div>

          {/* Button */}
          <div className=" w-md-auto">
            <a
              href="https://chat.whatsapp.com/DVOLOZpXjRfH5wovUoV5u4"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <button
                type="button"
                className="btn shadow-sm btn-round border w-100 w-md-auto account-whatsapp-btn"
              >
                <i className="fab fa-whatsapp" style={{ fontSize: "2rem" }}></i>
                <span>Join whatsapp for daily darshan and updates</span>
              </button>
            </a>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-12">
            <div className="card mb-4 account-settings-card">
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="card-body mb-3 account-settings-body">
                  <div className="row">
                    {/* Profile Pic */}
                    <div className="mb-3 col-md-4 text-center imgs-account-con">
                      <h6 className="fw-mediumbold mb-3">Profile Pic</h6>
                      <div className="imgs-account-bs">
                        {loadingImages.profile_pic ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary mt-2"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <img
                            src={
                              formData.profile_pic_url ||
                              "/assets/img/image-holder.jpg"
                            }
                            alt="profile_pic"
                            className="rounded account-imgs"
                          />
                        )}
                      </div>
                      {/* <div className="button-wrapper">
                        <label
                          htmlFor="profile_pic_file_upload"
                          className="btn btn-light shadow-sm btn-round border mt-4 mb-4"
                        >
                          <span className="d-none d-sm-block">Change</span>
                          <i className="bx bx-upload d-block d-sm-none"></i>
                          <input
                            type="file"
                            id="profile_pic_file_upload"
                            ref={profile_picInputRef}
                            className="account-file-input"
                            hidden
                            accept="image/png, image/jpeg"
                            onChange={(e) =>
                              handleFileChange(e, "profile_pic", "favicon_url")
                            }
                          />
                        </label>
                      </div> */}

                      <div className="button-wrapper">
                        <button
                          type="button" // Button type set karen
                          className="btn btn-light shadow-sm btn-round border mt-4 mb-4 account-cta-btn"
                          onClick={() => profile_picInputRef.current.click()}
                        >
                          Change Profile Picture
                          <i className="bx bx-upload ms-2"></i>{" "}
                          {/* Optional icon */}
                        </button>
                        <input
                          type="file"
                          id="profile_pic_file_upload"
                          ref={profile_picInputRef}
                          className="account-file-input"
                          hidden
                          accept="image/png, image/jpeg"
                          onChange={(e) =>
                            handleFileChange(e, "profile_pic", "favicon_url")
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="mb-3 col-md-4 text-center imgs-account-con">
                      <h6 className="fw-mediumbold mb-3">Patron Card</h6>
                      <div className="imgs-account-bs">
                        {loadingImages.profile_pic ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary mt-2"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <img
                            src={"/patroncard.png"}
                            alt="profile_pic"
                            className="rounded account-imgs"
                          />
                        )}
                      </div>
                      <div>
                        <label
                          className="btn btn-light shadow-sm btn-round border mt-4 mb-4"
                        >
                          <span className="d-none d-sm-block">Donwload Patron Card</span>
                        </label>
                        <button
                          type="button"
                          onClick={() =>
                            openReceiptModal(users.user_details_id)
                          }
                          className="btn btn-light shadow-sm btn-round border mt-4 mb-4"
                        >
                          Donwload Patron Card
                        </button>
                      </div>
                    </div> */}

                    <div className="mb-3 col-md-4 text-center imgs-account-con">
                      <h6 className="fw-mediumbold mb-3">Change Password</h6>

                      <div>
                        <button
                          type="button"
                          onClick={openOtpModal}
                          className="btn btn-light shadow-sm btn-round border mt-4 mb-4 account-cta-btn"
                        >
                          Change Password
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Form Fields */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label
                        htmlFor="full_name"
                        className="form-label bold-label"
                      >
                        Name
                      </label>
                      <input
                        type="text"
                        id="full_name"
                        className="form-control bold-border"
                        value={formData.full_name ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label
                        htmlFor="address"
                        className="form-label bold-label"
                      >
                        Address
                      </label>
                      <input
                        type="text"
                        id="address"
                        placeholder="for prasadam and magazine"
                        className="form-control bold-border"
                        value={formData.address ?? ""}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="mb-3 col-md-6">
                      <label
                        htmlFor="is_address_confirmed"
                        className="form-label bold-label"
                      >
                        Kindly confirm if your address is correct?
                      </label>
                      <select
                        className="form-select bold-border"
                        id="is_address_confirmed"
                        value={formData.is_address_confirmed}
                        onChange={handleChange}
                        name="is_address_confirmed" // Make sure this matches your state field name
                      >
                        <option value="">-- Select --</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>

                    {/* <div className="col-md-6 mb-3">
                      <label
                        htmlFor="is_booked_calendar"
                        className="form-label bold-label"
                      >
                        Would you like to book your Calendar for home delivery?
                      </label>

                      <select
                        id="is_booked_calendar"
                        className="form-select bold-border"
                        value={formData.is_booked_calendar ?? ""}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select Option
                        </option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div> */}

                    <div className="col-md-6 mb-3">
                      <label htmlFor="city" className="form-label bold-label">
                        City
                      </label>
                      <input
                        type="text"
                        id="city"
                        className="form-control bold-border"
                        value={formData.city ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="state" className="form-label bold-label">
                        State
                      </label>
                      <input
                        type="text"
                        id="state"
                        className="form-control bold-border"
                        placeholder="Enter your state"
                        value={formData.state ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label
                        htmlFor="zip_code"
                        className="form-label bold-label"
                      >
                        Zip Code
                      </label>
                      <input
                        type="text"
                        id="zip_code"
                        placeholder="Enter your zip code"
                        className="form-control bold-border"
                        value={formData.zip_code ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label
                        htmlFor="phone_number"
                        className="form-label bold-label"
                      >
                        Phone Number
                      </label>
                      <input
                        type="text"
                        id="phone_number"
                        className="form-control bold-border"
                        disabled
                        value={formData.phone_number ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label
                        htmlFor="whatsapp_number"
                        className="form-label bold-label"
                      >
                        Whatsapp Number
                      </label>
                      <input
                        type="text"
                        id="whatsapp_number"
                        placeholder="Enter your whatsapp number"
                        className="form-control bold-border"
                        value={formData.whatsapp_number ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="email" className="form-label bold-label">
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        className="form-control bold-border"
                        placeholder="Enter your email"
                        value={formData.email ?? ""}
                        onChange={handleChange}
                      />
                    </div>

                    {["SILVER", "GOLD", "DIAMOND"].includes(
                      formData.patronship_level,
                    ) && (
                      <div className="col-md-6 mb-3">
                        <label
                          htmlFor="btg_magazine_status"
                          className="form-label bold-label"
                        >
                          BTG Magazine
                        </label>
                        <select
                          id="btg_magazine_status"
                          className="form-select bold-border"
                          value={formData.btg_magazine_status ?? ""}
                          onChange={handleChange}
                        >
                          <option value="" disabled>
                            Select Option
                          </option>
                          <option value="home_delivery">Home Delivery</option>
                          <option value="collect_from_temple">
                            Collect from temple
                          </option>
                        </select>
                      </div>
                    )}
                    <div className="col-md-6 mb-3">
                      <label
                        htmlFor="connectivity_status bold-label"
                        className="form-label bold-label"
                      >
                        WhatApp Connectivity Status
                      </label>
                      <select
                        id="connectivity_status"
                        className="form-select bold-border"
                        value={formData.connectivity_status ?? ""}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select Option
                        </option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label
                        htmlFor="want_80g"
                        className="form-label bold-label"
                      >
                        Do you want 80G?
                      </label>

                      <select
                        id="want_80g"
                        className="form-select bold-border"
                        value={formData.want_80g ?? ""}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select Option
                        </option>
                        <option value="Y">Y</option>
                        <option value="N">N</option>
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label
                        htmlFor="date_of_birth"
                        className="form-label bold-label"
                      >
                        Date-of-Birth
                      </label>
                      <input
                        type="date"
                        id="date_of_birth"
                        disabled={role !== "admin"}
                        className="form-control bold-border"
                        placeholder="to receive prasadam and prayers"
                        value={formData.date_of_birth ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="pan_no" className="form-label bold-label">
                        Pan No
                      </label>
                      <input
                        type="text"
                        id="pan_no"
                        className="form-control bold-border"
                        value={formData.pan_no ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="mt-3">
                    <button
                      type="submit"
                      className="btn btn-dark btn-round me-2 account-save-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save changes"}
                    </button>
                    {/* <button
                      type="reset"
                      className="btn btn-outline-secondary btn-round"
                    >
                      Cancel
                    </button> */}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* OTP MODAL */}
        <div
          className="modal fade"
          id="staticBackdrop"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="staticBackdropLabel">
                    Enter OTP
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body ">
                  <div>
                    <button
                      type="button"
                      onClick={otpHandler}
                      disabled={otpSentLoader}
                      className="btn btn-light shadow-sm btn-round border mt-4 mb-4 account-cta-btn"
                    >
                      {otpSentLoader ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Sending...
                        </>
                      ) : (
                        "Send OTP"
                      )}
                    </button>
                  </div>

                  <p className="text-center">
                    Please enter the 6-digit OTP sent to your WhatsApp or Email.
                  </p>

                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      maxLength={6}
                      placeholder="Enter OTP"
                      value={otp ?? ""}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Enter new password"
                      value={newPassword ?? ""}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  {/* <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Cancel
                  </button> */}
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={otpLoader}
                    onClick={handleOtpSubmit}
                  >
                    {otpLoader ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </>
                    ) : otpLoader ? (
                      "Changing..."
                    ) : (
                      "Verify and change password"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Pdf Modal */}
        {showPdfModal && (
          <div
            className="modal show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Patron Card</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setShowPdfModal(false);
                      setReceiptDetails("");
                    }}
                  ></button>
                </div>

                {/*  Your Custom FOLK Content Goes Here */}
                <DonorCard ref={receiptRef} receiptDetails={receiptDetails} />

                <div className="modal-footer">
                  <button className="btn btn-success" onClick={downloadPdf}>
                    Download PDF
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowPdfModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountSettings;
